import React, { useEffect, useState, useRef } from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import Spinner from "../../component/loadingbar/Spinner";
import Export from "../../component/Export";
import Swal from "sweetalert2";
import TableViewer from "../../component/tableViewer/TableViewer";

const ViewPurchaselist = () => {
  const token = config.token;
  const [loading, setLoading] = useState(false);
  const [studentData, setStudentData] = useState([]);
  const [courses, setCourses] = useState([]);

  const [selectedChapterOrCourseOption, setSelectedChapterOrCourseOption] =
    useState("");
  const navigate = useNavigate();

  //  ------For TableViewer ------
  const studentDataRef = useRef([]);
  studentDataRef.current = studentData;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------
  const handleSelectedChapterOrCourseOption = (e) => {
    setSelectedChapterOrCourseOption(e.target.value);

    //fetch mcq bank
    fetchStudents(e.target.value);
  };
  //----------------------------------------------- Export xlsx File ----------------------------------------------
  const handleExport = () =>
    studentData.map((student) => {
      return {
        First_name: student?.first_name,
        Last_name: student?.last_name,
        Email: student?.email,
        Mobile_no: student?.mobileno,
        DOB: student?.dob,
      };
    });

  //----------------------------------------------- select / view Students table  -------------------------------------------------R
  // Fetch all Students
  const fetchStudents = async (id) => {
    setLoading(true);
    try {
      await fetch(`${config.host_url}/pages/purchase`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            // Successful response, update the Students state
            setStudentData(data.data);

            //  ------For TableViewer ------
            const studentsData = data.data.map((student) => ({
              student: student?.first_name + " " + student?.last_name,
              username: student?.user_name,
              email: student?.email,
              mobile: student?.mobileno,
              idNumber: student?.id,
            }));
            // console.log(studentsData);
            setRowData(studentsData);
            //  ------For TableViewer ------
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      console.log(error);
      triggerNotification("error", "Error fetching Students.");
    } finally {
      setLoading(false);
    }
  };
    useEffect(() => {
      fetchStudents();
    }, [token]);
  useEffect(() => {
    // Fetch course list
    fetch(`${config.host_url}course`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setCourses(data.data);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching media:", error);
      });
  }, [token]);

  //----------------------------------------------- select / view students table  -------------------------------------------------R
  const btnShowHandle = (id) => {
    const encodedId = window.btoa(encodeURIComponent(id));
    navigate(`/viewstudent/${encodedId}`);
  };

  //----------------------------------------------- update / edit student table  -------------------------------------------------R
  const btnEditHandle = (id) => {
    const encodedId = window.btoa(encodeURIComponent(id));
    navigate(`/addstudent/${encodedId}`);
  };

  // ---------------------------------------------------- Delete student ---------------------------------------------------------D
  // Show a confirmation dialog
  const btnDeleteHandle = (deleteId, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete student?. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeleteStudent(deleteId, i);
      }
    });
  };

  //If confirm then delete student
  const handleDeleteStudent = async (deleteId, i) => {
    try {
      await fetch(`${config.host_url}student/${deleteId}`, {
        method: "DELETE",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            triggerNotification("success", "student deleted successfully.");

            //  ------For TableViewer ------
            const updatedStudent = [...studentDataRef.current];
            updatedStudent.splice(i, 1);
            setStudentData(updatedStudent);
            const studentsData = updatedStudent.map((student) => ({
              student: student?.first_name + " " + student?.last_name,
              username: student?.user_name,
              email: student?.email,
              mobile: student?.mobileno,
              idNumber: student?.id,
            }));
            setRowData(studentsData);
            //  ------For TableViewer ------
          } else if (data.status === 401) {
            // Invalid Token
            triggerNotification("error", "Unauthenticated User");
          } else {
            // Internal Server Error or other HTTP errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error deleting student");
      console.log(error);
    }
  };

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    { field: "student", filter: true },
    { field: "username", filter: true },
    { field: "email", filter: true },
    { field: "mobile", filter: true },
  ];
  //  ------For TableViewer ------

  return (
    <>
      <Breadcrumb txt="Home" subpath={["View Course Purchase"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center row flex justify-between">
            <h5 className="mb-0 col-sm-3">View Course Purchase</h5>
            <div className="col-sm-3 flex justify-end mt-2">
              <Export onExport={handleExport} student />
            </div>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div>
              <div className="col-md-12 mt-2 px-3 pb-3">
                <div className=" form-floating form-floating-outline mb-4">
                  <select
                    className="form-select mx-auto"
                    id="coursedropdown"
                    aria-label="coursedropdown"
                    value={selectedChapterOrCourseOption}
                    onChange={handleSelectedChapterOrCourseOption}
                  >
                    <option value="" disabled selected className="text-center">
                      --- Select Course ---
                    </option>
                    {courses?.map((course) => (
                      <option key={course.course_id} value={course.course_id}>
                        {course.course_name}
                      </option>
                    ))}
                  </select>

                  <label htmlFor="coursedropdown">Courses</label>
                </div>
              </div>
              {rowData.length > 0 ? (
                <div className="px-3 pb-3  table-responsive">
                  {/* ------For TableViewer ------ */}
                  <TableViewer
                    rowData={rowData}
                    colDefs={colDefs}
                    onView={btnShowHandle}
                  />
                </div>
              ) : (
                <div></div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewPurchaselist;
